<template>
  <div id="app-center">
    <home-head></home-head>
    <home-nav></home-nav>
    <div class="center-box">
      <div class="center-list">
        <h3>分会申请</h3>
        <div class="center-left" style="padding-top: 0">
          <el-form ref="applyForm" :model="form" :rules="ruleValidate" label-width="130px">
            <el-alert
              :title="cueTitle"
              :type="cueType"
              :description="cueDesc"
              :closable="false"
              show-icon
              v-if="form.audit_status >=0"
            ></el-alert>
            <table class="table">
              <tr>
                <td colspan="2" class="sort-box">
                  <h3>基础信息</h3>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="分会名称：" prop="branch_name">
                    <el-input
                      :maxlength="64"
                      v-model="form.branch_name"
                      style="width: 80%"
                      size="small"
                      placeholder="请输入分会名称"
                      suffix-icon="el-icon-edit"
                      onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"
                    ></el-input>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item label="分会联系人：" prop="user_name">
                    <el-input
                      v-model="form.user_name"
                      style="width: 80%"
                      size="small"
                      :maxlength="40"
                      placeholder="请输入分会联系人"
                      suffix-icon="el-icon-edit"
                      onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"
                    ></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="联系人手机号：" prop="phone">
                    <el-input
                      :maxlength="11"
                      v-model="form.phone"
                      style="width: 80%"
                      size="small"
                      placeholder="请输入分会联系人手机号"
                      suffix-icon="el-icon-edit"
                    ></el-input>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item label="电子邮箱：" prop="email">
                    <el-input
                      :maxlength="50"
                      v-model="form.email"
                      style="width: 80%"
                      size="small"
                      placeholder="请输入电子邮箱"
                      suffix-icon="el-icon-edit"
                      onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"
                    ></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <el-form-item label="分会地址：">
                    <el-select
                      v-model="form.province_id"
                      size="small"
                      placeholder="请选择省份"
                      style="width: 30%"
                      @change="getCity"
                      :popper-append-to-body="false"
                    >
                      <el-option
                        v-for="item in provinceList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="form.city_id"
                      size="small"
                      ref="city"
                      placeholder="请选择城市"
                      style="width: 30%"
                      @change="getCounty"
                      :clearable="true"
                      :popper-append-to-body="false"
                    >
                      <el-option
                        v-for="item in cityList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="form.county_id"
                      size="small"
                      ref="county"
                      placeholder="请选择县/区"
                      style="width: 30%"
                      :clearable="true"
                      :popper-append-to-body="false"
                    >
                      <el-option
                        v-for="item in countyList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <el-form-item label="分会详细地址：">
                    <el-input
                      :maxlength="100"
                      v-model="form.branch_address"
                      style="width: 91%"
                      size="small"
                      placeholder="请输入分会详细地址"
                      suffix-icon="el-icon-edit"
                      onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"
                    ></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="分会负责人：">
                    <el-input
                      :disabled="true"
                      :value="volunteerInfo.user_name"
                      style="width: 80%"
                      size="small"
                      suffix-icon="el-icon-edit"
                    ></el-input>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item label="负责人联系方式：">
                    <el-input
                      :disabled="true"
                      :value="volunteerInfo.mobile"
                      style="width: 80%"
                      size="small"
                      suffix-icon="el-icon-edit"
                    ></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="checkBox">
                  <el-button
                    type="primary"
                    :disabled="btnDisabled"
                    style="background-color:#ccc;border-color:#ccc"
                    v-if="btnDisabled"
                  >提交</el-button>
                  <el-button type="primary" @click="submitForm()" v-else>提交</el-button>
                </td>
              </tr>
            </table>
          </el-form>
        </div>
      </div>
      <!-- <div class="center-footer">
        <div class="footer-content">
          <span>（建议您使用IE9及以上版本浏览器访问本网站）</span>
          <span>技术支持：长沙普益云软件科技有限公司</span>
        </div>
      </div>-->
    </div>
    <home-foot></home-foot>
  </div>
</template>
<script>
import Axios from "axios";
import baseUrl from "@/config/index";
import homeHead from "../Public/head";
import homeNav from "../Public/nav";
import homeFoot from "../Public/foot";
// import myPosition from "../Public/position";
export default {
  components: {
    homeHead,
    homeNav,
    homeFoot
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      let mobile = /^[1][0-9]{10}$/;
      if (!mobile.test(value)) {
        return callback(new Error("手机号码格式不正确！"));
      } else {
        return callback();
      }
    };
    return {
      provinceList: [],
      cityList: [],
      countyList: [],
      btnDisabled: false, //提交按钮状态
      cueTitle: "",
      cueType: "info",
      cueDesc: "",
      validateIds: [],
      skills: [],
      form: {
        branch_name: "", //分会名称
        province_id: null, //省
        city_id: null, //市
        county_id: null, //县
        branch_address: "", //单位地址
        user_name: "", //分会联系人
        phone: "", //联系方式
        email: "" //邮箱
      },
      volunteerInfo: {}, //志愿者信息
      ruleValidate: {
        user_name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        // province_id: [
        //   { required: true, message: "请选择地址", trigger: "change" },
        //   { validator: checkDistinct, trigger: "change" }
        // ],
        phone: [
          { required: true, message: "请输入联系手机号！", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],
        email: [
          { type: "email", message: "请输入正确的邮箱格式！", trigger: "blur" }
        ],
        branch_name: [
          { required: true, message: "请输入工会名称！", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    goto(name) {
      this.$router.push({ name: name });
    },

    getCity(value, ifEdit = false) {
      if (!ifEdit) {
        this.form.city_id = null;
        this.form.county_id = null;
      }

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 2, pid: value })
        .then(res => {
          this.cityList = res.data;
        });
    },
    getCounty(value, ifEdit = false) {
      if (!ifEdit) {
        this.form.county_id = null;
      }

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 3, pid: value })
        .then(res => {
          this.countyList = res.data;
        });
    },
    //判断是否为志愿者
    getVolunteerInfo() {
      this.$db.post(this.$db.config.getIfVolunteer, {}).then(res => {
        //获取基本信息
        if (res.code == 200) {
          if (res.data.length != 0) {
            this.volunteerInfo = res.data;
          } else {
            this.$confirm(
              "系统检测到您还未成为志愿者不能申请分会, 是否申请成为志愿者?",
              "提示",
              {
                confirmButtonText: "申请成为志愿者",
                cancelButtonText: "返回页面",
                type: "warning"
              }
            )
              .then(() => {
                sessionStorage.setItem("backUrl", this.$route.fullPath);
                this.$router.push({
                  name: "volunteerApply"
                });
              })
              .catch(() => {
                this.$router.push({ path: "/" });
                sessionStorage.removeItem("bread1");
                sessionStorage.removeItem("index");
              });
          }
        }
      });
    },
    //获取分会详情
    getBranchInfo() {
      this.$db.post(this.$db.config.getVolunteerBranchDetails, {}).then(res => {
        if (res.code == 200) {
          if (res.data) {
            this.form = res.data;
            if (res.data.province_id && res.data.city_id) {
              this.getCity(res.data.province_id, true);
              this.getCounty(res.data.city_id, true);

              this.$set(this.form, "province_id", res.data.province_id);
              this.$set(this.form, "city_id", res.data.city_id);
              this.$set(this.form, "county_id", res.data.county_id);
            }
            switch (res.data.audit_status) {
              case 0:
                this.cueTitle = "待审核";
                this.cueType = "warning";
                this.cueDesc = "您的信息已提交，请耐心等待审核结果~";
                break;
              case 1:
                this.cueTitle = "通过审核";
                this.cueType = "success";
                this.cueDesc = "恭喜您，申请分会成功~";
                this.btnDisabled = true;
                break;
              case 2:
                this.cueTitle = "审核不通过";
                this.cueType = "error";
                this.cueDesc =
                  "很抱歉，您的信息已被驳回。您还可以再次提交审核~";
                break;
              case 3:
                this.cueTitle = "审核拒绝";
                this.cueType = "error";
                this.cueDesc = "很抱歉，您的信息已被驳回。感谢您的参与~";
                this.btnDisabled = true;
                break;
            }
          }
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },

    judeLogin() {
      let loginInfo = sessionStorage.getItem("token");
      if (loginInfo) {
        //已登录
        sessionStorage.removeItem("backUrl");
        //判断是否为志愿者
        this.getVolunteerInfo();
        //获取详情
        this.getBranchInfo();
      } else {
        //未登录
        this.$confirm("系统检测到您暂未登录, 是否进行登录?", "登录提示", {
          confirmButtonText: "立即登录",
          cancelButtonText: "返回页面",
          type: "warning"
        })
          .then(() => {
            sessionStorage.setItem("backUrl", this.$route.fullPath);
            this.$router.push({ name: "login" });
          })
          .catch(() => {
            this.$router.push({ path: "/" });
            sessionStorage.removeItem("bread1");
            sessionStorage.removeItem("index");
          });
      }
    },

    //提交申请
    submitForm() {
      if (!sessionStorage.getItem("loginInfo")) {
        this.judeLogin();
      }

      this.$refs["applyForm"].validate(valid => {
        if (valid) {
          let loginInfo = sessionStorage.getItem("loginInfo");
          let userInfo = JSON.parse(loginInfo);
          let url = "";
          if (this.form.id) {
            url = this.$db.config.saveVolunteerBranch;
          } else {
            url = this.$db.config.addVolunteerBranch;
          }

          this.$db.post(url, this.form).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                duration: 1000,
                message: res.msg,
                onClose: function() {
                  setTimeout(location.reload(), 500);
                }
              });
              // this.$router.push({name: 'homeIndex'})
            }
          }); //获取技能
        } else {
          this.$message({
            type: "error",
            message: "请填写完整申请信息！"
          });
        }
      });
    }
  },
  mounted() {
    this.judeLogin();

    this.$db.post(this.$db.config.getRegionUrl, { level: 1 }).then(resp => {
      if (resp && resp.code == 200) {
        this.provinceList = resp.data;
      }
    });

    this.getCity(this.form.province_id);
  }
};
</script>
<style lang="scss" scoped>
#app-center {
  // width: 100%;
  // height: 100%;
  background-color: #f1f1f1;
  border: 1px solid #eee;
}
.inputBox {
  border: none;
  margin: 0;
  padding: 0;
  border-bottom: 1px solid #eee;
  outline: none;
  padding: 6px;
  color: #666;
}
.center-box {
  margin-bottom: 100px;
  margin-top: 40px;
  .center-list {
    max-width: 1200px;
    margin: 0 auto;
    // padding-top: 20px;
    > h3 {
      font-size: 20px;
      // font-weight: normal;
      padding: 22px 0;
      text-align: center;
      background-color: #fff;
      border-bottom: 1px solid #eee;
    }
    .center-left {
      background-color: #fff;
      width: 100%;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 14px;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
  .checkBox {
    position: relative;
    text-align: center;
    .check-box {
      text-align: center;
      margin-top: 20px;
      > span {
        color: #b60205;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .el-button--primary {
      background-color: #b60205;
      border-color: #b60205;
      margin: 20px 0;
    }
  }

  .comBox {
    > h3 {
      font-size: 18px;
      font-weight: normal;
      color: #333;
      text-align: center;
      padding: 12px 0;
    }
    > p {
      font-size: 16px;
      color: #666;
      padding: 12px 0;
      padding-left: 160px;
    }
    .perBox {
      padding: 12px 0;
      padding-bottom: 20px;
      text-align: right;
      font-size: 16px;
      color: #666;
      > input {
        margin: 0;
        padding: 0;
        border: none;
        outline: none;
        border-bottom: 1px solid #eee;
        padding: 12px 8px;
      }
    }
  }
  .center-footer {
    width: 100%;
    background-color: #9b0204;
    margin-top: 60px;
    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 22px 0;

      > span {
        font-size: 14px;
        color: #cb5c5e;
      }
    }
  }
  .table {
    width: calc(100% - 60px);
    margin: 20px 25px;
    > tr {
      .sort-box {
        > h3 {
          font-size: 18px;
          color: #333;
          padding: 12px 8px;
          background-color: #eee;
          width: calc(100%-16px);
          font-weight: normal;
        }
      }
    }
  }
  .table td {
    width: 50%;
    border-bottom: 1px dashed #eee;
  }
  .register_head {
    height: 30px;
    line-height: 30px;
    margin-left: 20px;
    font-size: 14px;
    font-weight: 600;
    // font-family: "微软雅黑";
    color: DimGray;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
    margin-right: 20px;
    //margin-bottom: 30px;
    .login {
      font-size: 12px;
      float: right;
      font-family: "微软雅黑";
      font-weight: 300;
      color: #ccc;
    }
  }
}
.mask-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  background: rgba(0, 0, 0, 0.8);
  .content-box {
    max-width: 1120px;
    margin: 5% auto;
    background-color: #fff;
    height: 80%;
    position: relative;
    padding: 0 40px;
    overflow: hidden;
    > i {
      position: absolute;
      top: 6px;
      right: 20px;
      color: #333;
      font-size: 50px;
      cursor: pointer;
    }
    .scoll-box {
      padding: 0 80px;
      margin: 5% 0;
      height: 85%;
      overflow-y: scroll;
      > h3 {
        font-size: 20px;
        color: #000;
        text-align: center;
        padding: 20px;
      }
      > h5 {
        font-size: 18px;
        color: #333;
        text-align: center;
        padding: 20px;
      }
      > h6 {
        font-size: 18px;
        color: #333;
        text-align: right;
        padding: 20px;
      }
      > p {
        font-size: 16px;
        color: #666;
        line-height: 30px;
        margin-bottom: 20px;
      }
    }
    .scoll-box::-webkit-scrollbar {
      display: none;
    }
  }
}
.service-box /deep/ .el-form-item__content {
  margin-left: 200px !important ;
}
.service-box /deep/ .el-form-item__label {
  width: 200px !important;
  margin-top: 4px;
  text-align: center;
}
.service-box1 /deep/ .el-form-item__content {
  margin-left: 240px !important ;
}
.service-box1 /deep/ .el-form-item__label {
  width: 240px !important;
  margin-top: 4px;
  text-align: center;
}
.center-box /deep/ .el-steps--simple {
  padding: 22px 8%;
  background-color: #eee;
}
.center-box /deep/ .el-form-item {
  margin-bottom: 0;
  margin: 12px 0;
}
.center-box /deep/ .el-input__inner:focus {
  border-color: #b60205;
}
.center-box /deep/ .el-textarea__inner:focus {
  border-color: #b60205;
}
.center-box /deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #b60205;
}
.center-box /deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #b60205;
  background: #b60205;
}
.center-box /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #b60205;
}
.center-box /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #b60205;
  background: #b60205;
}
.center-box /deep/ .el-checkbox__inner:hover {
  color: #b60205;
}
</style>



// WEBPACK FOOTER //
// src/components/Branch/branch_apply.vue